export const coachMarkRoutes = {
  '/dashboard': '/dashboard',
  '/companyAnalysis/summary': '/companyAnalysis/summary',
  '/companyAnalysis/summary?preferenceSetting=true':
    '/companyAnalysis/summary?preferenceSetting=true',
  '/companyAnalysis/financial/financialStatements':
    '/companyAnalysis/financial/financialStatements',
  '/companyAnalysis/financial/financialAnalysis':
    '/companyAnalysis/financial/financialAnalysis',
  '/companyAnalysis/financial/financialAnalysis?preferenceSetting=true':
    '/companyAnalysis/financial/financialAnalysis?preferenceSetting=true',
  '/companyAnalysis/peerAnalysis': '/companyAnalysis/peerAnalysis',
  '/dynamicReport': '/dynamicReport',
  '/portfolioInsights/summary': '/portfolioInsights/summary',
  '/portfolioInsights/finance': '/portfolioInsights/finance',
  '/portfolioInsights/score': '/portfolioInsights/score',
  '/alerts': '/alerts',
  '/alerts/settings': '/alerts/settings',
  '/library/savedPortfolios': '/library/savedPortfolios',
  '/library/detailsPortfolio': '/library/detailsPortfolio',
  '/library/downloadFiles': '/library/downloadFiles',
  '/library/filteredCompanies': '/library/filteredCompanies',
  '/screening': '/screening',
  '/screening/exportFileSettings': '/screening/exportFileSettings',
  '/screening/savedCriteria': '/screening/savedCriteria',
  '/domesticSearch/preview': '/domesticSearch/preview',
  '/internationalSearch/preview': '/internationalSearch/preview',
  '/cartAndOrders/confirmation': '/cartAndOrders/confirmation',
  '/cartAndOrders': '/cartAndOrders',
  '/userManagement/subscriptionPayment': '/userManagement/subscriptionPayment',
  '/userManagement/subscriptionPayment/packageList':
    '/userManagement/subscriptionPayment/packageList',
  '/userManagement/subscriptionPayment/orderDetail':
    '/userManagement/subscriptionPayment/orderDetail',
}

export const coachMarkIgnoreRoutes = {
  '/cartAndOrders/confirmation': '/cartAndOrders/confirmation',
}
